export const insufficientLiquidityError = {
  error: {
    errorCode: 102,
    message: "InsufficientLiquidity",
  },
};
